import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Turkish TC Kimlik No validator following Single Responsibility Principle
 */
export class TrValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Turkish TC Kimlik No',
      pattern: /^\d{11}$/,
      length: 11
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    const patternValidation = this.validateRegex(
      id,
      this.config.pattern,
      'Turkish TC Kimlik No must be exactly 11 digits'
    );
    if (!patternValidation.isValid) {
      return patternValidation;
    }

    // First digit cannot be 0
    if (id[0] === '0') {
      return ValidationResult.invalid('Turkish TC Kimlik No cannot start with 0');
    }

    return ValidationResult.valid();
  }

  validateChecksum(id) {
    // Calculate 10th digit
    let oddSum = 0;
    let evenSum = 0;
    
    for (let i = 0; i < 9; i++) {
      if (i % 2 === 0) {
        oddSum += parseInt(id[i]);
      } else {
        evenSum += parseInt(id[i]);
      }
    }
    
    const tenthDigit = ((oddSum * 7) - evenSum) % 10;
    if (tenthDigit !== parseInt(id[9])) {
      return ValidationResult.invalid('Invalid Turkish TC Kimlik No 10th digit');
    }
    
    // Calculate 11th digit
    let totalSum = 0;
    for (let i = 0; i < 10; i++) {
      totalSum += parseInt(id[i]);
    }
    
    const eleventhDigit = totalSum % 10;
    if (eleventhDigit !== parseInt(id[10])) {
      return ValidationResult.invalid('Invalid Turkish TC Kimlik No 11th digit');
    }

    return ValidationResult.valid('Valid Turkish TC Kimlik No');
  }
}